module.exports = __webpack_public_path__ + "static/media/techno-2.d8c4e9b4.png";